module.exports = __webpack_public_path__ + "static/media/leftCellBackground.6a756a80.png";